import services from "../../../http/index";
import * as types from "./mutations-types";

export const ActionDoGetServicesByCustomer = ({ commit }, payload = null) => {
    return services.api.request({
        url: "service/getServicesByCustomer",
        method: "post",
        data: payload || {}
    }).then(response => {
        commit(types.SET_SERVICES_LIST, response.data);
        return response.data;
    });
};

export const ActionDoGetServices = ({ commit }, payload = null) => {
    return services.api.request({
        url: "service",
        method: "get",
        data: payload || {}
    }).then(response => {
        commit(types.SET_SERVICES_LIST, response.data);
        return response.data;
    });
};